import { sendAmplitudeData } from './amplitude';

import UserAuth from '@services/auth';
import { CLICKED_LOGOUT } from '@constants/eventNames';

const signOut = (current_plan?: string) => {
  if (current_plan) sendAmplitudeData(CLICKED_LOGOUT, { current_plan });
  UserAuth.clearTokens();
  window.location.replace('/sign-in');
};

export { signOut };
